import { Injectable } from '@angular/core';

/** Jeton d'accès à l'API BaseRef (référentiels), conservé dans le stockage local (repris de l'ancien front). */
@Injectable({
  providedIn: 'root',
})
export class BaseDeRefService {
  private readonly BASEDEREF_KEY = 'basederef_token';

  getTokenFromLocal(): string | null {
    return localStorage.getItem(this.BASEDEREF_KEY);
  }

  setTokenLocal(token: string): void {
    localStorage.setItem(this.BASEDEREF_KEY, token);
  }
}
